<template>
  <div :class="['m-checkbox', { '--disabled': isDisabled }]">
    <div class="input-row">
      <input
        ref="input"
        :id="id"
        type="checkbox"
        :name="name"
        v-model="checked"
      >
      <label
        :for="id"
        v-html="label"
        :class="[{ '--checked': value }, { 'has-right-tooltip': !!tooltip }]"
      />
      <Tooltip
        v-if="tooltip"
        :text="tooltip"
      />
    </div>
  </div>
</template>

<script>
import Tooltip from '../Tooltip'

export default {
  name: 'FormCheckbox',
  components: {
    Tooltip
  },
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      required: false,
      default: false
    },
    setter: {
      type: Function,
      required: false,
      default: undefined
    },
    tooltip: {
      type: String,
      required: false,
      default: null
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    id () {
      return `checkbox-${this.name}`
    },
    checked: {
      get () {
        return this.value
      },
      set (e) {
        if (this.setter) {
          this.setter(e)
        }
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="less">
@import (reference) "./../../../less/shared/utilities.less";
@import "@{frontend_static_less}/public/modules/m-checkbox.less";

.m-checkbox.--disabled {
  filter: grayscale() opacity(40%);
  pointer-events: none;
}

.m-checkbox .input-row label {
  &::before {
    border-radius: 0.25rem;
    background-color: @white;
  }

  &.--checked::before {
    background-color: @text-link-color;
    border-color: @text-link-color;
  }

  &::after {
    color: @white;
    font-size: 0.6rem;
    transform: translateY(-50%) translateX(20%);
    font-weight: 900;
  }
}
</style>
